import React from "react";
import NewsFeed from "../views/dashboard/app/news-feed";
import Index from "../views/dashboard/index";

//app
import PublicEvent from "../views/dashboard/app/events/publicEvents";
import PublicBlog from "../views/dashboard/blog/publicBlog";
import UserProfile from "../views/dashboard/app/user-profile";
import UserPrivacySetting from "../views/dashboard/app/user-privacy-setting";
import FriendProfile from "../views/dashboard/app/friend-profile";
import FeedDetails from "../views/dashboard/app/feedDetails";
import ChallengeDetails from "../views/dashboard/app/challengeDetails";
import Notification from "../views/dashboard/app/notification";
import FriendRequest from "../views/dashboard/app/friend-request";
import PeopleYouMayKnow from "../views/dashboard/app/people-you-may-know";
import BlockedFollower from "../views/dashboard/app/blocked-follower";
import UserAccountSetting from "../views/dashboard/app/user-account-setting";
import UserProfileEdit from "../views/dashboard/app/user-profile-edit";

// blog pages
import BlogGrid from "../views/dashboard/blog/bloggrid";
import BlogList from "../views/dashboard/blog/bloglist";
import BlogDetail from "../views/dashboard/blog/blogdetail";
import PublicBlogDetails from "../views/dashboard/blog/publicBlogDetails";

// extrapages
import AboutUs from "../views/extrapages/about-us";
import PrivacyPolicy from "../views/extrapages/privacy-policy";
import TermsofUse from "../views/extrapages/terms-of-use";
import ContactUs from "../views/extrapages/contact/contact-us";

import MyBlog from "../views/dashboard/blog/myBlog";
import GameCategory from "../views/dashboard/app/game/game-category";
import TeachersHelper from "../views/dashboard/ai/teachers-helper";
import TeachersHelperList from "../views/dashboard/ai/teachers-helper-list";
import TeachersHelperDetails from "../views/dashboard/ai/teachers-helper-details";
import QuestionsList from "../views/dashboard/ai/questions-list";
import HomeWorkList from "../views/dashboard/ai/home-work-list";
import TestSubmitedList from "../views/dashboard/ai/test-submited-list";
import HomeworkSubmitedList from "../views/dashboard/ai/homework-submited-list";
import ActivityList from "../views/dashboard/ai/activity-list";
import AttendancePage from "../views/dashboard/ai/attendance";
import MyAttendancePage from "../views/dashboard/ai/my-attendance";
import HolidayPage from "../views/dashboard/app/holiday/holiday-list";
import DailyReports from "../views/dashboard/app/daily-reports";
import TeacherEmergencyContacts from "../views/dashboard/app/teacher-emergency-contacts";
import TeacherAllergy from "../views/dashboard/app/teacher-allergy";
import SchoolAnnouncements from "../views/dashboard/app/school-announcements";
import MenuChart from "../views/dashboard/app/menu-chart";
import AccidentReports from "../views/dashboard/app/accident-reports";
import IllnessReports from "../views/dashboard/app/illness-reports";
import TeacherLeaveApplications from "../views/dashboard/app/teacher-leave-applications";
import AllergyActionPlanList from "../views/dashboard/app/allergy-action-plan/allergy-action-plan-list";
import AllergyActionPlanForm from "../views/dashboard/app/allergy-action-plan/allergy-action-plan-form";
import LunchPlanWaiverList from "../views/dashboard/app/lunch-plan-waiver/lunch-plan-waiver-list";
import LunchPlanWaiverForm from "../views/dashboard/app/lunch-plan-waiver/lunch-plan-waiver-form";
import NoPeanutPolicyList from "../views/dashboard/app/no-peanut-policy/no-peanut-policy-list";
import NoPeanutPolicyForm from "../views/dashboard/app/no-peanut-policy/no-peanut-policy-form";
import EmergencyContactList from "../views/dashboard/app/emergency-contact/emergency-contact-list";
import EmergencyContactForm from "../views/dashboard/app/emergency-contact/emergency-contact-form";
import ChildRegistrationList from "../views/dashboard/app/child-registration/child-registration-list";
import ChildRegistrationForm from "../views/dashboard/app/child-registration/child-registration-form";
import LeaveApplication from "../views/dashboard/app/leave-application";
import StudentDashboard from "../views/dashboard/app/student-dashboard";

// Medication Administration
import MedicationAdministrationList from "../views/dashboard/app/medication/medication-list";
import NonMedicationAdministrationList from "../views/dashboard/app/non-medication/non-medication-list";
import {
  MedicationAdd,
  MedicationEdit,
  NonMedicationAdd,
  NonMedicationEdit,
  MedicationLogsView,
  NonMedicationLogsView
} from "../views/dashboard/app/medication";

export const DefaultRouter = [
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "dashboard/app/news-feed",
    element: <NewsFeed />,
  },
  {
    path: "dashboard/app/game/game-category",
    element: <GameCategory />,
  },
  {
    path: "dashboard/app/publicEvents",
    element: <PublicEvent />,
  },
  {
    path: "dashboard/app/public-blog",
    element: <PublicBlog />,
  },
  {
    path: "dashboard/app/profile",
    element: <UserProfile />,
  },
  {
    path: "dashboard/app/user-privacy-setting",
    element: <UserPrivacySetting />,
  },
  {
    path: "dashboard/app/friend-profile/:slug",
    element: <FriendProfile />,
  },
  {
    path: "dashboard/app/feedDetails/:slug",
    element: <FeedDetails />,
  },
  {
    path: "dashboard/app/challengeDetails/:slug",
    element: <ChallengeDetails />,
  },
  {
    path: "dashboard/app/notification",
    element: <Notification />,
  },
  {
    path: "dashboard/app/friend-request",
    element: <FriendRequest />,
  },
  {
    path: "dashboard/app/people-you-may-know",
    element: <PeopleYouMayKnow />,
  },
  {
    path: "dashboard/app/blocked-follower",
    element: <BlockedFollower />,
  },
  {
    path: "dashboard/app/user-account-setting",
    element: <UserAccountSetting />,
  },
  {
    path: "dashboard/app/user-profile-edit",
    element: <UserProfileEdit />,
  },
  {
    path: "dashboard/blog/blog-grid",
    element: <BlogGrid />,
  },
  {
    path: "dashboard/blog/blog-list",
    element: <BlogList />,
  },
  {
    path: "dashboard/blog/blog-detail/:slug",
    element: <BlogDetail />,
  },
  {
    path: "dashboards/blog/myBlog",
    element: <MyBlog />,
  },
  {
    path: "dashboard/blog/publicBlogDetails/:slug",
    element: <PublicBlogDetails />,
  },
  {
    path: "about-us",
    element: <AboutUs />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "terms-of-use",
    element: <TermsofUse />,
  },
  {
    path: "contact-us",
    element: <ContactUs />,
  },
  {
    path: "dashboard/app/teachers-helper",
    element: <TeachersHelper />,
  },
  {
    path: "dashboard/app/teachers-helper-list",
    element: <TeachersHelperList />,
  },
  {
    path: "dashboard/app/teachers-helper-details",
    element: <TeachersHelperDetails />,
  },
  {
    path: "dashboard/app/questions-list",
    element: <QuestionsList />,
  },
  {
    path: "dashboard/app/home-work-list",
    element: <HomeWorkList />,
  },
  {
    path: "dashboard/app/test-submited-list",
    element: <TestSubmitedList />,
  },
  {
    path: "dashboard/app/homework-submited-list",
    element: <HomeworkSubmitedList />,
  },
  {
    path: "dashboard/app/activity-list",
    element: <ActivityList />,
  },
  {
    path: "dashboard/app/attendance",
    element: <AttendancePage />,
  },
  {
    path: "dashboard/app/my-attendance",
    element: <MyAttendancePage />,
  },
  {
    path: "dashboard/app/student-dashboard",
    element: <StudentDashboard />,
  },
  {
    path: "dashboard/holiday",
    element: <HolidayPage />,
  },
  {
    path: "dashboard/daily-reports",
    element: <DailyReports />,
  },
  {
    path: "dashboard/app/teacher-emergency-contacts",
    element: <TeacherEmergencyContacts />,
  },
  {
    path: "dashboard/app/teacher-allergy",
    element: <TeacherAllergy />,
  },
  {
    path: "dashboard/app/school-announcements",
    element: <SchoolAnnouncements />,
  },
  {
    path: "dashboard/menu-chart",
    element: <MenuChart />,
  },
  {
    path: "dashboard/accident-reports",
    element: <AccidentReports />,
  },
  {
    path: "dashboard/illness-reports",
    element: <IllnessReports />,
  },
  {
    path: "dashboard/teacher-leave-applications",
    element: <TeacherLeaveApplications />,
  },
  {
    path: "dashboard/allergy-action-plan/list",
    element: <AllergyActionPlanList />,
  },
  {
    path: "dashboard/allergy-action-plan/add",
    element: <AllergyActionPlanForm />,
  },
  {
    path: "dashboard/allergy-action-plan/edit/:id",
    element: <AllergyActionPlanForm />,
  },
  {
    path: "dashboard/child-registration/list",
    element: <ChildRegistrationList />,
  },
  {
    path: "dashboard/child-registration/add",
    element: <ChildRegistrationForm />,
  },
  {
    path: "dashboard/child-registration/edit/:id",
    element: <ChildRegistrationForm />,
  },
  {
    path: "dashboard/lunch-plan-waiver/list",
    element: <LunchPlanWaiverList />,
  },
  {
    path: "dashboard/lunch-plan-waiver/add",
    element: <LunchPlanWaiverForm />,
  },
  {
    path: "dashboard/lunch-plan-waiver/edit/:id",
    element: <LunchPlanWaiverForm />,
  },
  {
    path: "dashboard/no-peanut-policy/list",
    element: <NoPeanutPolicyList />,
  },
  {
    path: "dashboard/no-peanut-policy/add",
    element: <NoPeanutPolicyForm />,
  },
  {
    path: "dashboard/no-peanut-policy/edit/:id",
    element: <NoPeanutPolicyForm />,
  },
  {
    path: "dashboard/emergency-contact/list",
    element: <EmergencyContactList />,
  },
  {
    path: "dashboard/emergency-contact/add",
    element: <EmergencyContactForm />,
  },
  {
    path: "dashboard/emergency-contact/edit/:id",
    element: <EmergencyContactForm />,
  },
  // Medication Administration Routes
  {
    path: "dashboard/app/medication/list",
    element: <MedicationAdministrationList />,
  },
  {
    path: "dashboard/app/medication/add",
    element: <MedicationAdd />,
  },
  {
    path: "dashboard/app/medication/edit/:id",
    element: <MedicationEdit />,
  },
  {
    path: "dashboard/app/medication/logs/:id",
    element: <MedicationLogsView />,
  },
  // Non-Medication Administration Routes
  {
    path: "dashboard/app/non-medication/list",
    element: <NonMedicationAdministrationList />,
  },
  {
    path: "dashboard/app/non-medication/add",
    element: <NonMedicationAdd />,
  },
  {
    path: "dashboard/app/non-medication/edit/:id",
    element: <NonMedicationEdit />,
  },
  {
    path: "dashboard/app/non-medication/logs/:id",
    element: <NonMedicationLogsView />,
  },
  {
    path: "dashboard/app/leave-application",
    element: <LeaveApplication />,
  }
];
